module.exports = __webpack_public_path__ + "static/media/icon-arrow-up-green.7fc65abd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-arrow-up-green.svg
// module id = 746
// module chunks = 0